import { ResourceConfig } from "config/config";
import { PermissionOperation, RecordType } from "graphql/generated/graphql";

export interface UserPermissionList {
    table_type: RecordType | null;
    project_id: string | null;
    operation: PermissionOperation | null;
}

type AllPermissionOperations = PermissionOperation | "all";

export interface PermissionData {
    [key: string]: AllPermissionOperations[];
}

export const getPermissionData = (permissionList: UserPermissionList[]) =>
    permissionList.reduce((acc: PermissionData, currentPermission: any) => {
        const currentResource = currentPermission.table_type
            ? currentPermission.table_type.toLowerCase()
            : "all";

        acc[currentResource] = [
            ...(acc[currentResource] ?? []),
            currentPermission.operation ?? "all",
        ];

        return acc;
    }, {});

export const hasSomeRequiredPermissions = (
    requiredPermissions: AllPermissionOperations[],
    permissionList?: AllPermissionOperations[]
) => requiredPermissions.some((permission) => permissionList?.includes(permission));

export const hasOrganizationAdminPermission = (permissionList: UserPermissionList[]) =>
    permissionList.some(
        (permission) =>
            permission.project_id === null &&
            permission.table_type === null &&
            permission.operation === null
    );

export const hasCreateUserPermission = (permissionData: PermissionData) =>
    hasSomeRequiredPermissions(["all", "CREATE"], permissionData?.all) ||
    hasSomeRequiredPermissions(["all", "CREATE"], permissionData?.user);

export const hasCreatablePermission = (permissionList?: AllPermissionOperations[]) =>
    hasSomeRequiredPermissions(["all", "CREATE"], permissionList);

export const getCreatableResourceList = (
    resourceList: ResourceConfig[],
    permissionData: PermissionData
) =>
    resourceList.filter((currentItem: ResourceConfig) => {
        if (
            hasCreatablePermission(permissionData.all) ||
            hasCreatablePermission(permissionData[currentItem.resourceName])
        ) {
            return true;
        }
        return false;
    });

export const hasUserUpdateWorkspacePermission = (permissionData: PermissionData) => {
    return (
        hasSomeRequiredPermissions(["all", "UPDATE"], permissionData.all) ||
        hasSomeRequiredPermissions(["all", "UPDATE"], permissionData.workspace)
    );
};
